<template>
  <div id="app">
    <div>
      <v-app>
        <AppBar v-on:openDrawerClicked="drawer = !drawer" />
        <Drawer v-model="drawer" />
        <v-main :style="main_bg_style">
          <v-container class="pa-0 pa-sm-3 pa-xl-6" fluid>
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
          </v-container>
        </v-main>
        <Footer />
        <v-btn class="to-top" fab dark color="primary" v-on:click="toTop()">
          <v-icon> mdi-arrow-collapse-up </v-icon>
        </v-btn>
        <DevEnv />
      </v-app>
    </div>
  </div>
</template>

<script>
import AppBar from "@/components/structures/AppBar";
import Footer from "@/components/structures/Footer";
import Drawer from "@/components/structures/Drawer";
import DevEnv from "@/components/structures/DevEnv";
import goTo from "vuetify/es5/services/goto";

export default {
  name: "App",
  components: {
    AppBar,
    Footer,
    Drawer,
    DevEnv,
  },

  data: () => ({
    drawer: null,
  }),

  computed: {
    main_bg_style() {
      const main_bg = "background-color: #e3e3e3;";
      return main_bg;
    },
  },

  methods: {
    toTop() {
      goTo(0);
    },
  },
};
</script>

<style scoped>
.to-top {
  position: fixed;
  right: 50px;
  bottom: 30px;
  z-index: 999;
}
</style>
